import ky from 'ky';

import { REACT_APP_API_URL } from 'api/constants/api-constants';

interface IRefreshTokenProps {
    refreshToken: string | null;
}

export const refreshUserToken = async ({
    refreshToken,
}: IRefreshTokenProps) => {
    // for refresh token we can't use apiClient,
    // cause it will go to afterResponse hook and ends in dead lock
    const response = await ky.post(
        // eslint-disable-next-line node/no-process-env
        `${REACT_APP_API_URL}/v1/sessions/refresh`,
        {
            json: { refreshToken },
        }
    );
    return await response.json();
};
